// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"c4aefa0e","205":"b726c867","551":"c2ddb01f"}[chunkId] + ".chunk.js";
};